export const pathes = {
    DEFAULT: '/',
    BASE_PATH: "/questionnaire-pwa",
    SURVEY_DETAILS: '/survey-details/:id',
    SURVEY_QUESTIONS: "/survey-questions/:id/:pageNum",  
    SURVEY_QUESTIONS_DEFAULT: "/survey-questions/:id",   
}